import React from "react";
import { Component } from "react";
import { notify } from "react-notify-toast";
import DeletePopup from "./ConfirmationBox";
import { addDays } from "date-fns";
import { connect } from "react-redux";

import "react-datepicker/dist/react-datepicker.css";
import "./UserProfile.css";
import FormField from "../../Components/FormField/FormField";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import { API } from "../../API";
import axios from "axios";
import { handleLogErrorToSlack } from "../../Helper";
import { CircularProgress } from "@mui/material";

export class UsiCheckForm extends Component {
  constructor(props) {
    super(props);

    if (!this.props.user) {
      window.location = "/login";
    }

    this.state = {
      deleteUsiPopup: false,
      filetype: true,
      file: null,
      preview: null,
      show: false,
      borderRadius: 0,
      width: 300,
      height: 200,
      scale: 1,
      image: "",
      allowZoomOut: false,
      showPopup: false,
    };
  }

  handleScale = (e) => {
    const scale = parseFloat(e.target.value);
    this.setState({ scale });
  };

  uploadDocument = (id) => {
    document.getElementById(id).click();
  };

  handleUsiFileChange = () => {
    var isValidFile = false;
    let usiFile = this.uploadUsi.files[0];
    let filesize = this.uploadUsi.files[0].size >> 10

    isValidFile = this.validateFile(usiFile, "usi");
    if (isValidFile) {
      this.setState({
        image: usiFile,
      });
      this.saveFile(usiFile);
    }
  };

  validateFile = (file, filename) => {
    let isValid = false;
    if (file !== null && file !== undefined) {
      isValid = true;
    }
    return isValid;
  };

  deleteFile = (isDelete, fileName, popupStatus) => {
    var popUpState = "delete" + fileName + "Popup";
    if (isDelete) {
      notify.show("File deleted successfully");
      this.props.handleStateChange("usi_filename", null);
      this.props.handleStateChange("usi_url", null);
    }
    this.setState({ [popUpState]: popupStatus });
  };

  onFileUpload = (filename, url) => {
    this.props.handleStateChange("usi_filename", filename);
    this.props.handleStateChange("usi_url", url);
  };

  saveFile = async (file) => {
    this.setState({
      isLoading: true
    });
    const fileName = 'usi'

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileName", `${fileName}`)
      const response = await API.uploadCompressedFileToS3(formData)
  
      const url = response?.data?.data
      const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
      const suffix = url.substring(cut_length, url.length);
      const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=";
      const new_url = prefix + suffix;
      this.onFileUpload(file.name, new_url);
      this.setState({
        isLoading: false
      });
    } catch (error) {
      this.setState({
        isLoading: false
      });
      handleLogErrorToSlack(error, true);
      notify.show(JSON.stringify(error), "error");
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="auth-text-top mb-5">
            {/* USI report downloaded date */}
            <FormDatePicker
              label="Report Downloaded Date"
              id="usi_downloaded_date"
              selected={this.props.state.usi_downloaded_date}
              placeholderText={new Date()
                .toLocaleDateString()
                .split(/\//)
                .join("-")}
              showYearDropdown
              showMonthDropdown
              isClearable
              showPopperArrow={false}
              minDate={addDays(new Date(), 0)}
              dropdownMode="select"
              dateFormatCalendar="MMMM"
              dateFormat="dd-MM-yyyy"
              yearDropdownItemNumber={10}
              scrollableYearDropdown
              value={this.props.state.usi_downloaded_date}
              onChange={this.props.handleDateChange}
              required
            />

            <FormField
              label="Upload"
              id="flUSI"
              name="userUSI"
              disabled
              required
              placeholder={
                this.props.state.usi_filename ||
                "Please attach a photo in PNG, JPEG or JPG format or a PDF file"
              }
              header={
                <>
                  {this.state.usi_status ? (
                    <HoverIcon
                      icon="check circle"
                      color="green"
                      text="This document has been verified!"
                    />
                  ) : (
                    <HoverIcon
                      icon="check circle"
                      color="grey"
                      text="This document has not been verified yet!"
                    />
                  )}
                  <HoverIcon
                    icon="info circle"
                    color="grey"
                    text="Please upload a file less than 600KB."
                  />
                </>
              }
              sideButton={{
                id: "btnUpload_usi",
                label: "Upload",
                type: "button",
                onClick: () => this.uploadDocument("usi"),
                disabled: this.props.state.usi_url,
              }}
              footer={
                this.props.state.usi_filename ? (
                  <div className="text-left d-flex">
                    <a href={`/NavigateToFileViewer?fileurl=${this.props.state.usi_url}`} target='_blank'>
                      <p className="uploaded-file-name mt-1 ml-1">
                        {this.props.state.usi_filename}
                      </p>
                    </a>
                    <i
                      className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                      onClick={() => this.setState({ deleteUsiPopup: true })}
                    ></i>
                    {this.state.deleteUsiPopup && (
                      <DeletePopup
                        togglePopup={(isDelete) =>
                          this.deleteFile(isDelete, "Usi", false)
                        }
                      />
                    )}
                  </div>
                ) : (
                  ""
                )
              }
            >
              {
                this.state.isLoading && (
                  <CircularProgress />
                )
              }
              <input
                type="file"
                id="usi"
                name="usi"
                onChange={() => this.handleUsiFileChange()}
                ref={(ref) => {
                  this.uploadUsi = ref;
                }}
                style={{ display: "none" }}
                accept="image/*, .pdf"
              />
            </FormField>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};
export default connect(mapStateToProps)(UsiCheckForm);
